import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import StateTags from '../components/StateTags';
import SubjectTags from '../components/SubjectTags';
import FilterBar from '../components/FilterBar';
import TutorCard from '../components/TutorCard';
import Pagination from '../components/Pagination';
import Footer from '../components/Footer';

const HomePage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const tutors = [
    {
      id: 1,
      name: "Rakibul Islam",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=200&h=200&auto=format&fit=crop",
      status: "Available",
      verified: true,
      premium: true,
      rating: 4.9,
      subjects: [
        { name: "Physics", icon: "fas fa-atom", className: "subject-physics" },
        { name: "Mathematics", icon: "fas fa-calculator", className: "subject-math" }
      ],
      location: "Uttara, Kolkata",
      education: "BSc in CSE, BUET",
      experience: "5 Years Experience",
      schedule: "Part-time / Full-time",
      badges: ["verified", "premium"]
    },
    {
      id: 2,
      name: "Nusrat Jahan",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=200&h=200&auto=format&fit=crop",
      status: "Available",
      verified: false,
      pending: true,
      popular: true,
      rating: 4.8,
      subjects: [
        { name: "English", icon: "fas fa-language", className: "subject-english" },
        { name: "Biology", icon: "fas fa-dna", className: "subject-biology" }
      ],
      location: "Dhanmondi, Dhaka",
      education: "MA in English, DU",
      experience: "3 Years Experience",
      schedule: "Evening Shift",
      badges: ["pending", "popular"]
    },
    {
      id: 3,
      name: "Mehedi Hasan",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=200&h=200&auto=format&fit=crop",
      status: "Available",
      verified: true,
      premium: true,
      popular: true,
      rating: 4.7,
      subjects: [
        { name: "Chemistry", icon: "fas fa-flask", className: "subject-chemistry" },
        { name: "Higher Math", icon: "fas fa-calculator", className: "subject-math" }
      ],
      location: "Halishahar, Chittagong",
      education: "BSc in Chemistry, CU",
      experience: "4 Years Experience",
      schedule: "Weekends Only",
      badges: ["verified", "premium", "popular"]
    },
    {
      id: 4,
      name: "Farhana Akter",
      image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=200&h=200&auto=format&fit=crop",
      status: "Busy",
      verified: true,
      popular: true,
      rating: 4.6,
      subjects: [
        { name: "ICT", icon: "fas fa-laptop-code", className: "subject-ict" },
        { name: "General Science", icon: "fas fa-microscope", className: "subject-science" }
      ],
      location: "Banani, Dhaka",
      education: "MSc in ICT, JU",
      experience: "2 Years Experience",
      schedule: "Morning Shift",
      badges: ["verified", "popular"]
    },
    {
      id: 5,
      name: "Ariful Haque",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=200&h=200&auto=format&fit=crop",
      status: "Available",
      verified: false,
      pending: true,
      rating: 4.9,
      subjects: [
        { name: "Social Science", icon: "fas fa-landmark", className: "subject-history" },
        { name: "History", icon: "fas fa-history", className: "subject-history" }
      ],
      location: "Rajshahi City",
      education: "BA in History, RU",
      experience: "6 Years Experience",
      schedule: "Flexible Timing",
      badges: ["pending"]
    }
  ];

  const handlePageChange = (page) => {
    setCurrentPage(page);
    console.log('Loading page:', page);
  };

  return (
    <>
      <div className="main-content">
        <Sidebar />
        <div className="content-area">
          <Header />
          <StateTags />
          <SubjectTags />
          <FilterBar />
          <div className="tutor-list">
            {tutors.map(tutor => (
              <TutorCard key={tutor.id} tutor={tutor} />
            ))}
          </div>
          <Pagination 
            currentPage={currentPage}
            totalPages={10}
            onPageChange={handlePageChange}
            totalTutors={50}
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default HomePage;